import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { CognitoService } from './cognito.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cognitoService = inject(CognitoService);
  return from(cognitoService.getIdToken()).pipe(
    switchMap((idToken) => {
      localStorage.setItem('idToken', idToken);
      const modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${idToken}`,
        },
      });
      return next(modifiedReq);
    }),
  );
};
